import { render } from "./BaseCard.vue?vue&type=template&id=7549f8b4&scoped=true"
const script = {}

import "./BaseCard.vue?vue&type=style&index=0&id=7549f8b4&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/twiga_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7549f8b4"]])

export default __exports__